import { Configuration, LogLevel } from '@azure/msal-browser'

// Support both naming conventions for environment variables
const clientId = import.meta.env.VITE_MSAL_CLIENT_ID || import.meta.env.VITE_ENTRA_CLIENT_ID || ''
const authority =
  import.meta.env.VITE_MSAL_AUTHORITY ||
  `https://login.microsoftonline.com/${import.meta.env.VITE_ENTRA_TENANT_ID || 'common'}`
const redirectUri = import.meta.env.VITE_MSAL_REDIRECT_URI || window.location.origin

export const msalConfig: Configuration = {
  auth: {
    clientId: clientId,
    authority: authority,
    redirectUri: redirectUri,
    postLogoutRedirectUri: redirectUri,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message)
            return
          case LogLevel.Warning:
            console.warn(message)
            return
        }
      },
    },
  },
}

// Scopes for login - request our API scope only
// Graph API scopes are handled by OBO flow in the backend (admin consent already granted)
export const loginRequest = {
  scopes: [`api://${clientId}/access_as_user`],
}

// Scopes for API calls
export const apiScopes = {
  scopes: [`api://${clientId}/access_as_user`],
}
